import { NavLink } from 'react-router-dom';
import { ActivityActionsProps } from '../types';
import { ActionMenuItem } from './ActionMenuItem';

export const GpaActions = ({ activity }: ActivityActionsProps) => {
  const activitykeyUrlEncoded = encodeURIComponent(activity?.activitykey ?? 'null');

  return (
    <>
      <NavLink to={'/gpl/' + activitykeyUrlEncoded}>
        <ActionMenuItem icon={'edit'} title={'Edit'} />
      </NavLink>
    </>
  );
};
